import {Ic} from "../../../models/common";
import {Utils} from "../../../common/utils";

/**
 * Created by claudio iozzia on 05/05/2017.
 */
export class Flyback {
  public static maxLimPower(ic: Ic, vinDC: number): number {
//  if ( ! isFinite(vinDC) )
//  	vinDC = ic.vin_min * Math.SQRT2;
//
//  const IdLim:Number       = 0.95 * ( ("@ILIM_min" in ic.designData) ? ic.designData.@ILIM_min : 0 );
//  const maxLimPower:Number = IdLim/2 * 0.45 * 0.75 * vinDC;
//
//  return maxLimPower;

    return Flyback.calculatePowerOutUpperBound(ic, vinDC);
  }

  static calculatePowerOutUpperBound(ic: Ic, vinMin_dc: number): number {
    if (!isFinite(vinMin_dc)) {
      vinMin_dc = ic.vin_min * Math.SQRT2;
    }


    const IdLimMin: number = Utils.getFieldValue(ic, "designData.ILIM_min", 0);
    const IdLim125: number = 0.95 * IdLimMin;

    const vinDcMin: number = 0.75 * vinMin_dc;
    const VR: number = 70;
    const eff: number = 0.73;
    const RdsOn: number = Utils.getFieldValue(ic, "designData.RdsOn", 0);

    const dMax: number = VR / (vinDcMin - RdsOn * 3 * IdLim125 + VR);

    const powerOutUpperBound: number = 0.5 * IdLimMin * eff * vinDcMin * dMax;

    return powerOutUpperBound;
  }

}
